import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_882c45c4 from 'nuxt_plugin_plugin_882c45c4' // Source: ./feature-toggle/plugin.js (mode: 'all')
import nuxt_plugin_vuescrollto_79c1f5ac from 'nuxt_plugin_vuescrollto_79c1f5ac' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_webfontloader_b9f5aa02 from 'nuxt_plugin_webfontloader_b9f5aa02' // Source: ./webfontloader.js (mode: 'client')
import nuxt_plugin_pluginrouting_a504a332 from 'nuxt_plugin_pluginrouting_a504a332' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_1c7d2e68 from 'nuxt_plugin_pluginmain_1c7d2e68' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_markdownit_bab3e442 from 'nuxt_plugin_markdownit_bab3e442' // Source: ./markdownit.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_7a77d4b2 from 'nuxt_plugin_cookieuniversalnuxt_7a77d4b2' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_httpserver_592c4dac from 'nuxt_plugin_httpserver_592c4dac' // Source: ./http.server.js (mode: 'server')
import nuxt_plugin_http_99d07b1e from 'nuxt_plugin_http_99d07b1e' // Source: ./http.js (mode: 'all')
import nuxt_plugin_strapi_2b5d2c90 from 'nuxt_plugin_strapi_2b5d2c90' // Source: ./strapi.js (mode: 'all')
import nuxt_plugin_gtm_0c500e95 from 'nuxt_plugin_gtm_0c500e95' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_ccc75802 from 'nuxt_plugin_axios_ccc75802' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_normalizeConfig_6f25b43b from 'nuxt_plugin_normalizeConfig_6f25b43b' // Source: ../plugins/normalizeConfig (mode: 'all')
import nuxt_plugin_vueintersect_34b8f824 from 'nuxt_plugin_vueintersect_34b8f824' // Source: ../plugins/vue-intersect (mode: 'all')
import nuxt_plugin_vuelazyimage_5a769146 from 'nuxt_plugin_vuelazyimage_5a769146' // Source: ../plugins/vue-lazy-image (mode: 'all')
import nuxt_plugin_veevalidate_346f6561 from 'nuxt_plugin_veevalidate_346f6561' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_swiper_419e176c from 'nuxt_plugin_swiper_419e176c' // Source: ../plugins/swiper (mode: 'client')
import nuxt_plugin_vuexpersist_61a29aad from 'nuxt_plugin_vuexpersist_61a29aad' // Source: ../plugins/vuex-persist (mode: 'client')
import nuxt_plugin_gdpr_926c18da from 'nuxt_plugin_gdpr_926c18da' // Source: ../plugins/gdpr (mode: 'client')
import nuxt_plugin_vuelinkify_71a285f2 from 'nuxt_plugin_vuelinkify_71a285f2' // Source: ../plugins/vue-linkify (mode: 'all')
import nuxt_plugin_vuedebounce_106b52b8 from 'nuxt_plugin_vuedebounce_106b52b8' // Source: ../plugins/vue-debounce (mode: 'all')
import nuxt_plugin_cms_25c73702 from 'nuxt_plugin_cms_25c73702' // Source: ../plugins/cms.js (mode: 'all')
import nuxt_plugin_seo_40a2336e from 'nuxt_plugin_seo_40a2336e' // Source: ../plugins/seo.js (mode: 'all')
import nuxt_plugin_warex_74f9d470 from 'nuxt_plugin_warex_74f9d470' // Source: ../plugins/warex.js (mode: 'all')
import nuxt_plugin_googlemaps_c54ce192 from 'nuxt_plugin_googlemaps_c54ce192' // Source: ../plugins/google-maps (mode: 'client')
import nuxt_plugin_hubspot_af1509fa from 'nuxt_plugin_hubspot_af1509fa' // Source: ../plugins/hubspot (mode: 'client')
import nuxt_plugin_jsonld_320ccf54 from 'nuxt_plugin_jsonld_320ccf54' // Source: ../plugins/jsonld (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"script":[{"src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient","async":true,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-KMQCPB6')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"link":[{"rel":"stylesheet","href":"https:\u002F\u002Ffonts.googleapis.com\u002Ficon?family=Material+Icons"},{"rel":"stylesheet","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fyakuhanjp@3.3.1\u002Fdist\u002Fcss\u002Fyakuhanjp.min.css"}],"htmlAttrs":{"prefix":"og: http:\u002F\u002Fogp.me\u002Fns#","lang":"ja"},"meta":[{"hid":"og:type","property":"og:type","content":"website"},{"hid":"robots","name":"robots","content":"index, follow"}],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-KMQCPB6&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_882c45c4 === 'function') {
    await nuxt_plugin_plugin_882c45c4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_79c1f5ac === 'function') {
    await nuxt_plugin_vuescrollto_79c1f5ac(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_webfontloader_b9f5aa02 === 'function') {
    await nuxt_plugin_webfontloader_b9f5aa02(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_a504a332 === 'function') {
    await nuxt_plugin_pluginrouting_a504a332(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_1c7d2e68 === 'function') {
    await nuxt_plugin_pluginmain_1c7d2e68(app.context, inject)
  }

  if (typeof nuxt_plugin_markdownit_bab3e442 === 'function') {
    await nuxt_plugin_markdownit_bab3e442(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_7a77d4b2 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_7a77d4b2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_httpserver_592c4dac === 'function') {
    await nuxt_plugin_httpserver_592c4dac(app.context, inject)
  }

  if (typeof nuxt_plugin_http_99d07b1e === 'function') {
    await nuxt_plugin_http_99d07b1e(app.context, inject)
  }

  if (typeof nuxt_plugin_strapi_2b5d2c90 === 'function') {
    await nuxt_plugin_strapi_2b5d2c90(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_0c500e95 === 'function') {
    await nuxt_plugin_gtm_0c500e95(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ccc75802 === 'function') {
    await nuxt_plugin_axios_ccc75802(app.context, inject)
  }

  if (typeof nuxt_plugin_normalizeConfig_6f25b43b === 'function') {
    await nuxt_plugin_normalizeConfig_6f25b43b(app.context, inject)
  }

  if (typeof nuxt_plugin_vueintersect_34b8f824 === 'function') {
    await nuxt_plugin_vueintersect_34b8f824(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyimage_5a769146 === 'function') {
    await nuxt_plugin_vuelazyimage_5a769146(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_346f6561 === 'function') {
    await nuxt_plugin_veevalidate_346f6561(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_swiper_419e176c === 'function') {
    await nuxt_plugin_swiper_419e176c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuexpersist_61a29aad === 'function') {
    await nuxt_plugin_vuexpersist_61a29aad(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gdpr_926c18da === 'function') {
    await nuxt_plugin_gdpr_926c18da(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelinkify_71a285f2 === 'function') {
    await nuxt_plugin_vuelinkify_71a285f2(app.context, inject)
  }

  if (typeof nuxt_plugin_vuedebounce_106b52b8 === 'function') {
    await nuxt_plugin_vuedebounce_106b52b8(app.context, inject)
  }

  if (typeof nuxt_plugin_cms_25c73702 === 'function') {
    await nuxt_plugin_cms_25c73702(app.context, inject)
  }

  if (typeof nuxt_plugin_seo_40a2336e === 'function') {
    await nuxt_plugin_seo_40a2336e(app.context, inject)
  }

  if (typeof nuxt_plugin_warex_74f9d470 === 'function') {
    await nuxt_plugin_warex_74f9d470(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlemaps_c54ce192 === 'function') {
    await nuxt_plugin_googlemaps_c54ce192(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hubspot_af1509fa === 'function') {
    await nuxt_plugin_hubspot_af1509fa(app.context, inject)
  }

  if (typeof nuxt_plugin_jsonld_320ccf54 === 'function') {
    await nuxt_plugin_jsonld_320ccf54(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
